import window from 'window-or-global';
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

// Stylesheet.
require('./iosediting.css');

function iOSEditingPlugin() {
	/**
	 * UX tweak so users understand how to comment using the iPad.
	 */
	return {
		init(ed) {
			if (window.tinymce.Env.iOS) {
				setTimeout(() => {
					const $body = $(ed.getBody());
					$body.addClass('ios');
				}, 0);
			}
		},
		getInfo() {
			return {
				longname: 'iOS Comments Plugin',
				author: 'Atlassian',
				authorurl: 'http://www.atlassian.com',
				version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
			};
		},
	};
}

export default function () {
	window.tinymce.create('tinymce.plugins.iOSEditing', iOSEditingPlugin());
	window.tinymce.PluginManager.add('iosediting', window.tinymce.plugins.iOSEditing);
}
